export const GOT_DEFAULT_PRICE_FINALLY = (defaultWorkPrice: number) => {
  return { type: "GOT_DEFAULT_PRICE_FINALLY", payload: defaultWorkPrice };
};
